// Viewport is read at call time, never cached at load, so resize/rotate is handled.
function kgIsMobileNav() {
    return window.matchMedia("(max-width: 999px)").matches;
}

// Shared teardown. Previously copy-pasted across three handlers.
function kgCloseMenu() {
    $('html').removeClass('kg_navigation_active');
    $('#kg-nav-menu').removeClass('kg_nav_active');
    $('.kg-side-navigation').removeClass('nav_active');
    $('#kg_nav li').removeClass('nav_active');
    $('.kg-nav-item-back').remove();
    $('.kg-top-browse').remove();
    $('.kg-header-overlay').removeClass('kg-active-overlay');
    $('.kg-side-navigation .nav_link:first .kg-nav-close-button').remove();
}

$(document).on("click", "#kg_nav li > a", function(event) {

    if ((!$(event.target).is("a")) && (!$(event.target).hasClass("kg_open_menu"))) {
        return;
    }
    $('.kg-header-overlay').addClass('kg-active-overlay');
    if (($(this).closest('li').find('.kg-menu').length >= 1) || ($(this).closest('li').find('.kg-submenu ').length >= 1)) {
        event.preventDefault();
        $('html').addClass('kg_navigation_active');
        if (kgIsMobileNav()) {
            var kgSideNav = document.getElementById('kg-side-navigation');
            if (kgSideNav) kgSideNav.scrollIntoView();
        }
        if ($(this).closest('li').hasClass("nav_active")) {
            $(this).closest('li').removeClass('nav_active');
            $('.kg-nav-item-back').remove();
        } else {
            var cat_name = $.trim(jQuery(this).text());
            $('.kg-nav-item-back').remove();
            jQuery(this).closest('li').find('.kg-sub-child-group:first').prepend('<div class="kg-nav-item-back"><span class="kg-nav-back-button"><img src="https://cdn.shopify.com/s/files/1/0267/5100/8962/files/LeftArrow.svg?v=1694755630" class="kg_bck_menu"></span><h3 class="kg-nav-item-title">' + cat_name + '</h3><span class="kg-nav-close-button"><img src="https://cdn.shopify.com/s/files/1/0267/5100/8962/files/Cross.svg?v=1694755630"></span></div>');
            $('#kg_nav li:not(.kg-side-navigation)').not($(this).parents('.nav_active')).removeClass('nav_active');
            $(this).closest('li').addClass('nav_active');
        }
    }
});
$(document).on("click", ".header__mobile-nav-toggle", function(event) {
    $('html').toggleClass('kg_navigation_active');
    $('.kg-side-navigation').toggleClass('nav_active');
    $('#kg-nav-menu').toggleClass('kg_nav_active');
    $('.kg-header-overlay').toggleClass('kg-active-overlay');
    $('.kg-top-browse').remove();
    $('.kg-side-navigation').prepend('<span class="kg-top-browse">Browse<span class="kg-nav-close-button"><img src="https://cdn.shopify.com/s/files/1/0267/5100/8962/files/Cross.svg?v=1694755630" ></span></span>');
});

jQuery(document).on("click", ".kg-nav-item-back .kg-nav-back-button", function(e) {
    e.preventDefault();
    jQuery(this).closest('li').removeClass('nav_active');
    jQuery(this).parent().remove();
});

$(document).on("click", ".kg-menu-close-button,.kg-nav-close-button", function(e) {
    kgCloseMenu();
});

// Single outside-click handler. Was two handlers bound once at load against a
// cached width, so resizing past the breakpoint left the wrong one active.
$(document).on("click", "html", function(e) {
    if ($(e.target).parents('.nav_active').length) return;
    if (kgIsMobileNav()) {
        if ($(e.target).parents('.header__mobile-nav').length) return;
        if ($(e.target).parents('.kg-nav-back-button').length) return;
    }
    kgCloseMenu();
});

// Top-level nav overflow trimming is now handled entirely in CSS
// (assets/kg-menu.css, nth-of-type breakpoint cascade) so the final bar is
// present at first paint with no JS pop-in. No JS resize/ready hook needed.

if (window.matchMedia("(max-width: 767px)").matches) {
    jQuery(function() {
        var maxHeight = 0;
        jQuery('.kg-collection-item__title').each(function(index) {
            if (jQuery(this).height() > maxHeight) {
                maxHeight = jQuery(this).height();
            }
        });
        jQuery('.kg-collection-item__title').height(maxHeight);
    });
}
$(document).ready(function() {
//     // Function to toggle "Read More" and "Read Less" on click
//     $('.read-more-trigger').click(function() {
//         var content = $('.read-more-content');
//         content.toggleClass('read-more-show');
//         if (content.hasClass('read-more-show')) {
//             content.css('max-height', content[0].scrollHeight + 'px');
//             $(this).text('Read Less');
//         } else {
//             content.css('max-height', '6em'); // Adjust this value based on your content
//             $(this).text('Read More');
//         }
//     });

    jQuery('.kg-accordian-item h2, .kg-accordian-item h3, .kg-accordian-item .kg-tab-heading').on('click', function() {
        if (jQuery(this).hasClass('active')) {
            jQuery(this).siblings('.elementor-tab-content').slideUp();
            jQuery(this).removeClass('active');
        } else {
            jQuery('.elementor-tab-content').slideUp();
            jQuery('.kg-accordian-item h2, .kg-accordian-item h3, .kg-accordian-item .kg-tab-heading').removeClass('active');
            jQuery(this).siblings('.elementor-tab-content').slideToggle();
            jQuery(this).toggleClass('active');
        }
    });

});
document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".kg-accordian-item");

  accordions.forEach((item) => {
    item.addEventListener("toggle", () => {
      if (item.open) {
        // Close all other accordions
        accordions.forEach((other) => {
          if (other !== item) {
            other.removeAttribute("open");
          }
        });
      }
    });
  });
});


/*
 * GST price display.
 *
 * Which price is visible (.kg-excluding-price vs .kg-including-price) is decided
 * entirely in CSS, off the single #kg-gst-state checkbox declared at the top of
 * <body> in layout/theme.liquid. That is what makes the toggle work with
 * JavaScript disabled.
 *
 * So nothing here may show/hide those elements: jQuery .show()/.hide()/.css()
 * writes an inline style that overrides the stylesheet and would freeze the
 * price in whatever state it was left in. JS owns the cookie, nothing else.
 *
 * The default is INC GST and is expressed once, by the `checked` attribute on
 * that input; the inline script in theme.liquid applies a saved Excl preference
 * before first paint, so there is no INC->EX flicker on load. gstToggle() below
 * only re-syncs the checkbox from the cookie after async content loads (e.g. the
 * cart drawer), and no-ops when there is no cookie.
 */
document.addEventListener("theme:loading:end", function (e) {
   gstToggle();
});


$(document).ready(function() {
   gstToggle();
});

function gstToggle(){
    var price_type = Cookies.get('price_type');
    // No cookie => leave the checkbox alone. The default is expressed once, by
    // the `checked` attribute in theme.liquid, and the pre-paint script there
    // has already honoured it. Restating it here would be a second source of
    // truth that can silently drift out of step with the markup.
    if (typeof price_type === 'undefined') return;
    $('#kg-gst-state').prop('checked', price_type === 'Incl');
}
// Persist the shopper's choice. The visual swap is CSS; this only remembers it.
$(document).on("change", "#kg-gst-state", function() {
    Cookies.set('price_type', this.checked ? 'Incl' : 'Excl');
});
$(document).on('click', '#myModal .close_modal', function() {
    $("#myModal").hide();
});

// Open-quote handler moved to dashboard quote.js (window.quotefunction +
// delegated .button_quote_click). Disabled here to avoid adding the SKU twice.
/*
$(document).on('click', '.button_quote_click', function() {
    if (product_sku == '') {
        product_sku = $(this).attr('title');
    }
    // showLoader();
    $.ajax({
        url: "https://dashboard2.restaurantequipment.com.au/api/quotes",
        type: "GET",
        data: {
            cart_token: cart_token,
            product_sku: product_sku,
            region: (window.REO_REGION || 'au')
        },
        dataType: "json",
        contentType: "application/json;",
        success: function(data) {
            // hideLoader();
            if (data.success == true) {
                $('#modal_html').html(data.html);
                // console.log(modal, "modal modal");
                $("#myModal").show();
                $('body').find('#product_sku').trigger('change');

            }
        },
        error: function(err) {
            //hideLoader();
        }
    });
})
*/


var uuid = function() {
    var u = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
        function(c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    return u;
}

var getDeviceId = function() {
    var current = window.localStorage.getItem("_DEVICEID_")

    if (current) return current;
    var id = uuid();
    window.localStorage.setItem("_DEVICEID_", id);
    return id;
}
var cart_token = getDeviceId();

const placeholderTexts = [
    "Search 10,000+ Products",
    "Search Commercial Fridges",
    "Search Commercial Freezers",
    "Search Ice Machines",
    "Search Deep Fryers",
    "Search Cooking Equipment",
    "Search Commercial Ovens",
    "Search Commercial Dishwashers"
];

let index = 0;

function rotatePlaceholder() {
    const searchInput = $('.search-bar__input');
    searchInput.attr('placeholder', placeholderTexts[index]);
    index = (index + 1) % placeholderTexts.length;
}
setInterval(rotatePlaceholder, 1000);

jQuery("#kg-enquire-now").on('click', function() {
    jQuery('html, body').scrollTop(jQuery("#kg-contact-form").offset().top - 170);
});
/*
 * toggleMiniCartPrices() and its MutationObserver used to live here, setting
 * display on .kg-including-cart-price / .kg-excluding-cart-price by hand. The
 * same CSS rules that drive every other price now cover the mini-cart, and they
 * apply to AJAX-injected markup for free -- so both the function and the
 * document-wide observer are gone.
 */



(function ($) {
    const GST_RATE = 0.10;
    const BASE_PRICE_DATA_ATTR = 'data-original-price';
    let basePricesStored = false;
    let isProcessingAjax = false;

    function formatPrice(val) {
        return '$' + val.toFixed(2);
    }

    // Current GST mode, read from the single sitewide checkbox (theme.liquid).
    function isIncludingGst() {
        const el = document.getElementById('kg-gst-state');
        return !!el && el.checked;
    }

    function extractPriceFromText(text) {
        const match = text.match(/\$([\d,.]+)/);
        return match ? parseFloat(match[1].replace(/,/g, '')) : null;
    }

    function storeOriginalPrices() {
        if (basePricesStored && !isProcessingAjax) return;

        // .kg-price and .shipping_cost were removed from this selector. Every
        // .kg-price is rendered TWICE by Liquid -- once inside .kg-excluding-price
        // and once inside .kg-including-price (product-collection-list.liquid,
        // main-collection.liquid, main-search.liquid, and the JS-built cards in
        // kg-product-custom.js) -- so this loop was stamping both copies of the
        // same price and re-taxing whichever one the CSS shows. .shipping_cost is
        // not rendered anywhere. This IIFE now owns only the quote modal, which is
        // the externally supplied markup it was written for.
        $('#product_html [id^="sku-"], #product_html td').each(function () {
            const $el = $(this);
            const text = $el.text().trim();
            const price = extractPriceFromText(text);

            if (!price) return;

            // The quote-modal HTML arrives INC GST from the dashboard API and is
            // not re-rendered when the shopper flips the switch, so the base must
            // never be inferred from the current toggle state.
            const originalPrice = price / (1 + GST_RATE);

            $el.attr(BASE_PRICE_DATA_ATTR, originalPrice.toFixed(2));
        });
        
        basePricesStored = true;
        isProcessingAjax = false;
    }

    function storeNewElementPrices() {
        // Same selector and same INC-GST base as storeOriginalPrices() above.
        $('#product_html [id^="sku-"], #product_html td').each(function () {
            const $el = $(this);

            if ($el.attr(BASE_PRICE_DATA_ATTR)) return;

            const text = $el.text().trim();
            const price = extractPriceFromText(text);

            if (!price) return;

            const originalPrice = price / (1 + GST_RATE);

            $el.attr(BASE_PRICE_DATA_ATTR, originalPrice.toFixed(2));
        });
    }

    function applyGST(includeGST) {
        
        $('[' + BASE_PRICE_DATA_ATTR + ']').each(function () {
            const $el = $(this);
            const originalPrice = parseFloat($el.attr(BASE_PRICE_DATA_ATTR));
            
            if (isNaN(originalPrice)) return;
            
            let finalPrice;
            if (includeGST) {
                finalPrice = originalPrice * (1 + GST_RATE);
            } else {
                finalPrice = originalPrice;
            }
            
            $el.html(function(i, html) {
                return html.replace(/\$[\d,.]+/, formatPrice(finalPrice));
            });
        });
    }

    function syncWithToggle() {
        storeNewElementPrices();
        
        const isIncluding = isIncludingGst();
        applyGST(isIncluding);
    }

    $(document).ready(function() {
        /*
         * This used to force the toggle to unchecked here. Because this ready
         * handler is registered after gstToggle()'s, it ran second and undid the
         * cookie restore -- a returning INC GST shopper got INC prices with the
         * switch stuck in the EX position. The checkbox state is now owned by the
         * inline script in theme.liquid and gstToggle(); read it, never set it.
         */
        setTimeout(function() {
            storeOriginalPrices();
            applyGST(isIncludingGst());
        }, 500);
    });

    $(document).ajaxComplete(function(event, xhr, settings) {
        if (settings.url && settings.url.includes('/shipping-estimator') || 
            typeof settings.data === 'string' && settings.data.includes('postcode')) {
            
            isProcessingAjax = true;
            
            setTimeout(function() {
                // Same selector and same INC-GST base as storeOriginalPrices().
                $('#product_html [id^="sku-"], #product_html td').each(function () {
                    const $el = $(this);
                    const text = $el.text().trim();
                    const price = extractPriceFromText(text);

                    if (!price) return;

                    const originalPrice = price / (1 + GST_RATE);
                    $el.attr(BASE_PRICE_DATA_ATTR, originalPrice.toFixed(2));
                });
                
                const isIncluding = isIncludingGst();
                applyGST(isIncluding);
                
                isProcessingAjax = false;
            }, 300);
        }
    });

    const observer = new MutationObserver(function(mutations) {
        let hasNewContent = false;
        
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length > 0) {
                hasNewContent = true;
            }
        });
        
        if (hasNewContent && !isProcessingAjax) {
            setTimeout(function() {
                storeNewElementPrices();
                
                const isIncluding = isIncludingGst();
                applyGST(isIncluding);
            }, 200);
        }
    });

    const containers = ['product_html', 'shipping_message', 'inventory_div'];
    containers.forEach(function(containerId) {
        const container = document.getElementById(containerId);
        if (container) {
            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }
    });

    $(document).on('change', '#kg-gst-state', function () {
        
        applyGST(this.checked);
    });

  
    $(document).on('input', '#product_sku_estimator', function() {
        basePricesStored = false;
    });

})(jQuery);

$('.faq-q').on('click', function () {
    var $item = $(this).closest('.faq-item');
    var $answer = $item.find('.faq-a');

    if ($item.hasClass('active')) {
        $item.removeClass('active');
        $answer.stop(true, true).slideUp(300);
    } else {
        $('.faq-list .faq-item.active')
            .removeClass('active')
            .find('.faq-a')
            .stop(true, true)
            .slideUp(300);

        $item.addClass('active');
        $answer.stop(true, true).slideDown(300);
    }
});